module.exports = function xor (a, b) {
  var length = Math.min(a.length, b.length)
  var buffer = new Buffer(length)

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i]
  }

  return buffer
}



//////////////////
// WEBPACK FOOTER
// ./~/buffer-xor/index.js
// module id = 54
// module chunks = 1